import './index.css'
import cn from 'clsx'

import React from 'react'
export type Props = {
  iconNode?: React.ReactNode
  children?: any
  className?: string
}

const Item = (props: Props): React.ReactElement<'li'> => {
  const { className, children, iconNode, ...rest } = props
  return (
    <li {...rest} className={cn('List_Item', className)}>
      {iconNode}
      {children}
    </li>
  )
}

export default Item
